import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InicioComponent } from './Components/inicio/inicio.component';
import { PrimerComponent} from './Components/primer/primer.component';
import { NopaginaComponent} from './Components/nopagina/nopagina.component'
import { FormularioComponent} from './Components/formulario/formulario.component'
import { MenuComponent} from './Components/menu/menu.component'
import { EmpresaFormComponent } from "./Components/empresa-form/empresa-form.component";
import { RutEmpresaFormComponent } from "./Components/rut-empresa-form/rut-empresa-form.component";
import { RepresentLegalFormComponent } from "./Components/represent-legal-form/represent-legal-form.component";
import { DetSolicitudComponent } from './Components/det-solicitud/det-solicitud.component';
import { CertDdjjVpComponent } from './Components/cert-ddjj-vp/cert-ddjj-vp.component';


const APP_ROUTES: Routes = [
  { path: 'inicio', component: InicioComponent },
  { path: 'primer', component: PrimerComponent },
  { path: 'formulario', component: FormularioComponent },
  { path: 'menu', component: MenuComponent },
  { path: 'empresa-form', component: EmpresaFormComponent },
  { path: 'rut-empresa-form', component: RutEmpresaFormComponent },
  { path: 'represent-legal-form', component: RepresentLegalFormComponent },
  { path: 'det-solicitud', component: DetSolicitudComponent},
  { path: 'cert-ddjj-vp', component: CertDdjjVpComponent},
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  { path: '**', component: NopaginaComponent }

];


export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES,{useHash: false});

